// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__LGFXA","list":"BalanceDue_list__3SFeh","listRow":"BalanceDue_listRow__6qSRc","total":"BalanceDue_total__2JJOt"};